import './Main.css'
import { FC, useContext } from "react";
import { Col, Row } from 'antd';
import { MenuComponent } from './Menu/Menu';
import { Social } from './Social/Social';
import { Logo } from './Logo/Logo';
import { ResponsiveContext } from '../../context/responsive-context';
import { TransparentButton } from '../../common-components/CustomButtons';

export const Main: FC = () => {
  const { isMobile } = useContext(ResponsiveContext)
  return (
    <>
    {isMobile &&
    <div className="Main-container-mobile">
    <Row style={{ height: '100%' }}>
      <Col span={24} style={{ height: '100%' }}>
        <Row style={{ height: 'calc(100%/3)'}}>
        <Row style={{ height: '10%', width: '100%'}}>
          <Col span={16}>
          <Social />
          </Col>
          <Col span={8}>
          <MenuComponent />
          </Col>
        </Row>
        <Row style={{ height: '90%', padding: 70, paddingTop: 40 }}>
          <Col span={24} style={{ alignContent: 'center' }}>
           <Logo />
          </Col>
        </Row>
        </Row>
        <Row style={{ height: 'calc(100%/3)'}}>
          <Col span={24} style={{ textAlign: 'center', alignContent: 'end', paddingBottom: 50 }}>
              <TransparentButton
              href='#book'
              >
              <div style={{letterSpacing: 2, fontFamily: 'GlacialIndifferenceBold'}}>
              FOGLALÁS
              </div>
              </TransparentButton>
          </Col>
        </Row>
        <Row style={{ height: 'calc(100%/3)'}}>
        <Col span={24} style={{ alignContent: 'center'}} >
        </Col>
        </Row>
      </Col>
    </Row>
    </div>
    }
    {!isMobile &&
    <div className="Main-container">
    <Row style={{ height: '100%' }}>
      <Col span={16} style={{ height: '100%' }}>
        <Row style={{ height: 'calc(100%/3)'}}>
          <Col span={12}>
          <Social />
          </Col>
          <Col span={12} style={{ alignContent: 'center' }}>
           <Logo />
          </Col>
        </Row>
        <Row style={{ height: 'calc(100%/3)'}}>
        </Row>
        <Row style={{ height: 'calc(100%/3)'}}>
          <Col span={12}></Col>
          <Col span={12} style={{ textAlign: 'center', alignContent: 'end', paddingBottom: 50 }}>
              <TransparentButton
              href='#book'
              >
              <div style={{letterSpacing: 2, fontFamily: 'GlacialIndifferenceBold'}}>
              FOGLALÁS
              </div>
              </TransparentButton>
          </Col>
        </Row>
      </Col>
      <Col span={8}>
      <MenuComponent />
      </Col>
    </Row>
    </div>
    }
    </>
  )
}
